function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "12914681-4D32-4C91-8D3D-0250B8B0019B");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Applications",
  transform: "translate(-894.000000, -286.000000)",
  stroke: "#07A9F4"
}, React.createElement("g", {
  id: "Profile_Icon",
  transform: "translate(894.000000, 286.000000)"
}, React.createElement("circle", {
  id: "Oval-9",
  cx: 7,
  cy: 7,
  r: 6.5
}), React.createElement("ellipse", {
  id: "Oval-path",
  cx: 6.8553719,
  cy: 5.62451066,
  rx: 1.83829926,
  ry: 1.77435842
}), React.createElement("path", {
  d: "M6.8553719,7.41485428 C4.3776642,7.41485428 3.94606351,9.63679861 3.86613745,10.3081775 C3.85015224,10.4200739 3.73825576,12.5863333 3.86613745,12.5863333 C4.85988473,13.1458839 5.85363201,13.4256592 6.8473793,13.4256592 C7.84112658,13.4256592 8.83487386,13.1458839 9.82862114,12.5863333 C9.95650283,12.5863333 9.84460635,10.4040887 9.82862114,10.3081775 C9.7646803,9.6208134 9.3330796,7.41485428 6.8553719,7.41485428 Z",
  id: "Path"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-profile.0c6238bb.svg";
export { SvgComponent as ReactComponent };